import React from "react";
import clsx from "clsx";
import { makeStyles, useTheme } from "@material-ui/core/styles";
import Drawer from "@material-ui/core/Drawer";
import AppBar from "@material-ui/core/AppBar";
import Toolbar from "@material-ui/core/Toolbar";
import List from "@material-ui/core/List";
import CssBaseline from "@material-ui/core/CssBaseline";
import Typography from "@material-ui/core/Typography";
import Divider from "@material-ui/core/Divider";
import IconButton from "@material-ui/core/IconButton";
import MenuIcon from "@material-ui/icons/Menu";
import ChevronLeftIcon from "@material-ui/icons/ChevronLeft";
import ChevronRightIcon from "@material-ui/icons/ChevronRight";
import ListItem from "@material-ui/core/ListItem";
import ListItemIcon from "@material-ui/core/ListItemIcon";
import ListItemText from "@material-ui/core/ListItemText";

import AccountCircle from "@material-ui/icons/AccountCircle";
import NotificationsIcon from "@material-ui/icons/Notifications";
import AddIcon from "@material-ui/icons/Add";
import SearchIcon from "@material-ui/icons/Search";
import DashboardIcon from "@material-ui/icons/Dashboard";
import TvIcon from "@material-ui/icons/Tv";
import EventAvailableIcon from "@material-ui/icons/EventAvailable";
import SettingsIcon from "@material-ui/icons/Settings";
import HelpIcon from "@material-ui/icons/Help";

import Badge from "@material-ui/core/Badge";
import InputBase from "@material-ui/core/InputBase";
import { fade } from "@material-ui/core/styles";
import Menu from "@material-ui/core/Menu";
import MenuItem from "@material-ui/core/MenuItem";

import Logo from "../img/logo.png";

import { Switch, Link, Route } from "react-router-dom";
import Dashboard from "../pages/dashboard";
import Meeting from "../pages/meeting";
import Calendar from "../pages/calendar";
import Settings from "../pages/settings";
import Help from "../pages/help";
import Profile from "../pages/profile";
import Notification from "../pages/notification";
import editMeeting from "../pages/editMeeting";
import CreateMeeting from "../pages/createMeeting";
import meetingDetails from "../pages/meetingDetails";

// dialog
import Button from "@material-ui/core/Button";
import TextField from "@material-ui/core/TextField";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogTitle from "@material-ui/core/DialogTitle";

const drawerWidth = 240;

const useStyles = makeStyles((theme) => ({
	root: {
		display: "flex",
	},
	appBar: {
		zIndex: theme.zIndex.drawer + 1,
		transition: theme.transitions.create(["width", "margin"], {
			easing: theme.transitions.easing.sharp,
			duration: theme.transitions.duration.leavingScreen,
		}),
	},
	appBarShift: {
		marginLeft: drawerWidth,
		width: `calc(100% - ${drawerWidth}px)`,
		transition: theme.transitions.create(["width", "margin"], {
			easing: theme.transitions.easing.sharp,
			duration: theme.transitions.duration.enteringScreen,
		}),
	},
	menuButton: {
		marginRight: 36,
	},
	hide: {
		display: "none",
	},
	drawer: {
		width: drawerWidth,
		flexShrink: 0,
		whiteSpace: "nowrap",
	},
	drawerOpen: {
		width: drawerWidth,
		transition: theme.transitions.create("width", {
			easing: theme.transitions.easing.sharp,
			duration: theme.transitions.duration.enteringScreen,
		}),
	},
	drawerClose: {
		transition: theme.transitions.create("width", {
			easing: theme.transitions.easing.sharp,
			duration: theme.transitions.duration.leavingScreen,
		}),
		overflowX: "hidden",
		width: theme.spacing(7) + 1,
		[theme.breakpoints.up("sm")]: {
			width: theme.spacing(7) + 1,
		},
	},
	toolbar: {
		display: "flex",
		alignItems: "center",
		justifyContent: "flex-end",
		padding: theme.spacing(0, 1),
		...theme.mixins.toolbar,
	},
	content: {
		flexGrow: 1,
		padding: theme.spacing(3),
	},
	// lateradded
	grow: {
		flexGrow: 1,
	},
	menuButton: {
		marginRight: theme.spacing(2),
	},
	title: {
		display: "none",
		[theme.breakpoints.up("sm")]: {
			display: "block",
		},
	},
	search: {
		position: "relative",
		borderRadius: theme.shape.borderRadius,
		backgroundColor: fade(theme.palette.common.white, 0.15),
		"&:hover": {
			backgroundColor: fade(theme.palette.common.white, 0.25),
		},
		marginRight: theme.spacing(2),
		marginLeft: 0,
		width: "100%",
		[theme.breakpoints.up("sm")]: {
			marginLeft: theme.spacing(3),
			width: "auto",
		},
	},
	searchIcon: {
		width: theme.spacing(7),
		height: "100%",
		position: "absolute",
		pointerEvents: "none",
		display: "flex",
		alignItems: "center",
		justifyContent: "center",
	},
	inputRoot: {
		color: "inherit",
	},
	inputInput: {
		padding: theme.spacing(1, 1, 1, 7),
		transition: theme.transitions.create("width"),
		width: "100%",
		[theme.breakpoints.up("md")]: {
			width: 200,
		},
	},
	sectionDesktop: {
		display: "none",
		[theme.breakpoints.up("md")]: {
			display: "flex",
		},
	},
	sectionMobile: {
		display: "flex",
		[theme.breakpoints.up("md")]: {
			display: "none",
		},
	},
}));

export default function MiniDrawer() {
	const classes = useStyles();
	const theme = useTheme();
	const [open, setOpen] = React.useState(false);

	const handleDrawerOpen = () => {
		setOpen(true);
	};

	const handleDrawerClose = () => {
		setOpen(false);
	};

	// lateradded
	const [anchorEl, setAnchorEl] = React.useState(null);
	const [mobileMoreAnchorEl, setMobileMoreAnchorEl] = React.useState(null);

	const isMenuOpen = Boolean(anchorEl);
	const isMobileMenuOpen = Boolean(mobileMoreAnchorEl);

	const handleProfileMenuOpen = (event) => {
		setAnchorEl(event.currentTarget);
	};

	const handleMobileMenuClose = () => {
		setMobileMoreAnchorEl(null);
	};

	const handleMenuClose = () => {
		setAnchorEl(null);
		handleMobileMenuClose();
	};

	// const handleMobileMenuOpen = event => {
	// 	setMobileMoreAnchorEl(event.currentTarget);
	// };

	// addmeeting icon
	const [modalopen, modalsetOpen] = React.useState(false);

	const handleClickOpen = () => {
		modalsetOpen(true);
	};

	const handleMeetingMenuOpen = (event) => {
		setAddMeetingAnchorEl(event.currentTarget);
	};

	const handleClose = () => {
		modalsetOpen(false);
	};

	const [anchorAddMeetingEl, setAddMeetingAnchorEl] = React.useState(null);
	// const [mobileMoreAnchorEl, setMobileMoreAnchorEl] = React.useState(null);

	const isAddMeetingMenuOpen = Boolean(anchorAddMeetingEl);
	// const isMobileMenuOpen = Boolean(mobileMoreAnchorEl);

	const handleAddMeetingMenuClose = () => {
		setAddMeetingAnchorEl(null);
		handleMobileMenuClose();
	};

	const addMeetingMenuId = "primary-search-account-menu";
	const renderAddMeetingMenu = (
		<Menu
			anchorEl={anchorAddMeetingEl}
			anchorOrigin={{ vertical: "top", horizontal: "right" }}
			id={addMeetingMenuId}
			keepMounted
			transformOrigin={{ vertical: "top", horizontal: "right" }}
			open={isAddMeetingMenuOpen}
			onClose={handleAddMeetingMenuClose}
			className="down"
		>
			<MenuItem onClick={handleAddMeetingMenuClose}>
				<div onClick={handleClickOpen}>Join Meeting</div>
			</MenuItem>
			<MenuItem onClick={handleAddMeetingMenuClose}>
				<Link to="/create-meeting">Create Meeting</Link>
			</MenuItem>
		</Menu>
	);
	// addmeeting icon

	const menuId = "primary-search-account-menu";
	const renderMenu = (
		<Menu
			anchorEl={anchorEl}
			anchorOrigin={{ vertical: "top", horizontal: "right" }}
			id={menuId}
			keepMounted
			transformOrigin={{ vertical: "top", horizontal: "right" }}
			open={isMenuOpen}
			onClose={handleMenuClose}
			className="down"
		>
			<MenuItem onClick={handleMenuClose}>
				<Link to="/profile">Profile</Link>
			</MenuItem>
			<MenuItem onClick={handleMenuClose}>
				<Link to="/">Logout</Link>
			</MenuItem>
		</Menu>
	);

	const mobileMenuId = "primary-search-account-menu-mobile";
	const renderMobileMenu = (
		<Menu
			anchorEl={mobileMoreAnchorEl}
			anchorOrigin={{ vertical: "top", horizontal: "right" }}
			id={mobileMenuId}
			keepMounted
			transformOrigin={{ vertical: "top", horizontal: "right" }}
			open={isMobileMenuOpen}
			onClose={handleMobileMenuClose}
		>
			<MenuItem>
				<IconButton
					aria-label="show 4 new mails"
					color="inherit"
					onClick={handleMeetingMenuOpen}
				>
					<Badge badgeContent={4} color="secondary">
						<AddIcon />
					</Badge>
				</IconButton>
				<p>Add Meeting</p>
			</MenuItem>
			<MenuItem>
				<IconButton aria-label="show 11 new notifications" color="inherit">
					<Badge badgeContent={11} color="secondary">
						<NotificationsIcon />
					</Badge>
				</IconButton>
				<p>Notifications</p>
			</MenuItem>
			<MenuItem onClick={handleProfileMenuOpen}>
				<IconButton
					aria-label="account of current user"
					aria-controls="primary-search-account-menu"
					aria-haspopup="true"
					color="inherit"
				>
					<AccountCircle />
				</IconButton>
				<p>Profile</p>
			</MenuItem>
		</Menu>
	);
	// lateraddedend

	return (
		<React.Fragment>
			<div className={classes.root}>
				<CssBaseline />
				<AppBar
					position="fixed"
					className={clsx(classes.appBar, {
						[classes.appBarShift]: open,
					})}
				>
					<Toolbar>
						<IconButton
							color="inherit"
							aria-label="open drawer"
							onClick={handleDrawerOpen}
							edge="start"
							className={classes.menuButton}
						>
							<MenuIcon />
						</IconButton>
						<div className="logo_search">
							<Typography className={classes.title} variant="h6" noWrap>
								MeetingSpace
							</Typography>

							<div className={classes.search}>
								<div className={classes.searchIcon}>
									<SearchIcon />
								</div>
								<InputBase
									placeholder="Search…"
									classes={{
										root: classes.inputRoot,
										input: classes.inputInput,
									}}
									inputProps={{ "aria-label": "search" }}
								/>
							</div>
						</div>
						<div className={classes.grow} />
						<div className={classes.sectionDesktop}>
							<IconButton
								aria-label="show 4 new mails"
								color="inherit"
								onClick={handleMeetingMenuOpen}
							>
								<AddIcon />
							</IconButton>
							<Link to="/notifications">
								<IconButton aria-label="show new notifications" color="inherit">
									<Badge color="secondary">
										<NotificationsIcon />
									</Badge>
								</IconButton>
							</Link>
							<IconButton
								edge="end"
								aria-label="account of current user"
								aria-controls={menuId}
								aria-haspopup="true"
								onClick={handleProfileMenuOpen}
								color="inherit"
							>
								<AccountCircle />
							</IconButton>
						</div>
					</Toolbar>
				</AppBar>
				{renderMobileMenu}
				{renderMenu}
				{renderAddMeetingMenu}
				<Drawer
					variant="permanent"
					className={clsx(classes.drawer, {
						[classes.drawerOpen]: open,
						[classes.drawerClose]: !open,
					})}
					classes={{
						paper: clsx({
							[classes.drawerOpen]: open,
							[classes.drawerClose]: !open,
						}),
					}}
					open={open}
				>
					<div className={classes.toolbar}>
						<div
							className="logo"
							style={{
								display: "flex",
								alignItems: "center",
								justifyContent: "center",
								width: "100%",
							}}
						>
							<img src={Logo} alt="website logo" style={{ width: 70 }} />
						</div>
						<IconButton onClick={handleDrawerClose}>
							{theme.direction === "rtl" ? (
								<ChevronRightIcon />
							) : (
								<ChevronLeftIcon />
							)}
						</IconButton>
					</div>
					<Divider />
					<List>
						<Link to="/dashboard">
							<ListItem button>
								<ListItemIcon>
									<DashboardIcon />
								</ListItemIcon>
								<ListItemText primary={"Dashboard"} />
							</ListItem>
						</Link>
						<Link to="/meeting">
							<ListItem button>
								<ListItemIcon>
									<TvIcon />
								</ListItemIcon>
								<ListItemText primary={"Meeting"} />
							</ListItem>
						</Link>
						<Link to="/calendar">
							<ListItem button>
								<ListItemIcon>
									<EventAvailableIcon />
								</ListItemIcon>
								<ListItemText primary={"Calendar"} />
							</ListItem>
						</Link>
					</List>
					<Divider />
					<List>
						<Link to="/settings">
							<ListItem button>
								<ListItemIcon>
									<SettingsIcon />
								</ListItemIcon>
								<ListItemText primary={"Settings"} />
							</ListItem>
						</Link>
						<Link to="/help">
							<ListItem button>
								<ListItemIcon>
									<HelpIcon />
								</ListItemIcon>
								<ListItemText primary={"Help"} />
							</ListItem>
						</Link>
					</List>
				</Drawer>
				<main className={classes.content}>
					<div className={classes.toolbar} />
					<Switch>
						<Route exact path="/dashboard" component={Dashboard} />
						<Route exact path="/meeting" component={Meeting} />
						<Route exact path="/calendar" component={Calendar} />
						<Route exact path="/settings" component={Settings} />
						<Route exact path="/help" component={Help} />
						<Route exact path="/profile" component={Profile} />
						<Route exact path="/notifications" component={Notification} />
						<Route exact path="/create-meeting" component={CreateMeeting} />
						<Route exact path="/edit-meeting" component={editMeeting} />
						<Route exact path="/meeting-details" component={meetingDetails} />
					</Switch>
				</main>
			</div>
			<div>
				<Dialog
					open={modalopen}
					onClose={handleClose}
					aria-labelledby="form-dialog-title"
				>
					<DialogTitle id="form-dialog-title">Join Meeting</DialogTitle>
					<DialogContent>
						<TextField
							autoFocus
							margin="dense"
							id="name"
							label="Meeting Code"
							type="text"
							fullWidth
						/>
					</DialogContent>
					<DialogActions>
						<Button onClick={handleClose} color="primary">
							Cancel
						</Button>
						<Button onClick={handleClose} color="primary">
							Join
						</Button>
					</DialogActions>
				</Dialog>
			</div>
		</React.Fragment>
	);
}
